export default "__VITE_ASSET__28ukbKS3__"